// extracted by mini-css-extract-plugin
export var circle = "_fd-1";
export var exitConfirmationModal = "_fd-5";
export var iframe = "_fd-0";
export var offline = "_fd-3";
export var online = "_fd-2";
export var workstationSelectError = "_fd-4";